import React, { useEffect, useState, useRef } from "react";
import ResourcesTab from "./ResourcesTab";
import { useDispatch, useSelector } from "react-redux";
import * as rssFeedActions from "../../store/education/actions";
import * as rssWebinarsFeedActions from "../../store/webinars/actions";
import * as rssInfographicsFeedActions from "../../store/infographics/actions";
import * as ConfigurationActions from "../../store/configurationService/actions";
import { ApplicationState } from "../../store";
import { useHistory } from "react-router-dom";
import i18nService from "../../util/Internationalization/i18n/i18n";
import { staticURLs } from "../../config/urls";
import RssFeedDetails from "./RssFeedDetails";
import { getFormattedDate } from "../../util/dateFormatting";

const BusinessEducation = () => {
    const history = useHistory();
    const dispatch = useDispatch();
    const userType = "business";
    const requestArticleData = () => dispatch(rssFeedActions.actionCreators.getRssFeedData(userType));
    const requestWebinarsData = () => dispatch(rssWebinarsFeedActions.actionCreators.getWebinarsRssFeedData(userType));
    const requestInfographicsData = () => dispatch(rssInfographicsFeedActions.actionCreators.getInfographicsRssFeedData(userType));
    const educationData = useSelector((state: ApplicationState) => (state.educationState ? state.educationState.educationData : []));
    const isLoading = useSelector((state: ApplicationState) => (state.educationState ? state.educationState.isLoading : false));
    const webinarsData = useSelector((state: ApplicationState) => (state.webinarsState ? state.webinarsState.webinarsData : []));
    const infographicsData = useSelector((state: ApplicationState) => (state.infographicsState ? state.infographicsState.infographicsData : []));
    const routeLoading = useSelector((state: ApplicationState) => state.configurationState && (state.configurationState.loading || false));
    const [isDetails, setIsDetails] = useState(false);
    const [detailFeedId, setDetailFeedId] = useState("");
    
    useEffect(() => {
        window.scrollTo(0, 0);
        requestArticleData();
        requestWebinarsData();
        requestInfographicsData();
        if (history.location.search != null && history.location.search.length > 0) {
            educationData?.map((data:any)=>{
                if(data.feedUrl.split("resources/")[1].replace("/", "") ==history.location.search.replace("?", "")){
                    setDetailFeedId(data.feedUrl);
                    changeDetailsView();
                }
            })
        }
    }, []);

    useEffect(() => {
        if (routeLoading) {
            dispatch(ConfigurationActions.actionCreators.setRouteLoading(false));
        }
    }, [dispatch, routeLoading]);

    const changeFeedId = (feedUrl: string) => {
        setDetailFeedId(feedUrl);
        changeDetailsView();
    };

    const changeDetailsView = () => {
        history.push("/resources/business-education");
        setIsDetails(!isDetails);
    };

    return (
        <React.Fragment>
            <div className=" row">
                <div className="col-xs-12">
                    <h1 className="title-page" id="title-page" tabIndex={-1}>
                        Resources
                    </h1>
                </div>
            </div>

            <ResourcesTab selectedTab="4" />

            {!isDetails ? (
                <div className="row" id="content">
                    <div className="col-xs">
                        <div className="box offset-padding">
                            <div className="box-header">
                                <div className="box-title-container">
                                    <div className="box-title-icon" aria-hidden="true">
                                        <em className="las la-graduation-cap"></em>
                                    </div>
                                    <div className="box-title-text">
                                        <h2 className="box-title">Education</h2>
                                    </div>
                                </div>
                            </div>
                            <div className="box-content">
                                {!isLoading ? (
                                    <>
                                        <div className="row">
                                            <div className="col-xs-12 col-gutter-vertical">
                                                <h3 className="content-sub-title">Articles</h3>

                                                <ul className="article-list">
                                                    {educationData != null &&
                                                        educationData.map((data: any, index: number) => (
                                                            <li key={index}>
                                                                <div className="article-container">
                                                                    <div className="article-image">
                                                                        <a
                                                                            rel="noreferrer"
                                                                            href="javascript:void(0);"
                                                                            onClick={() => {
                                                                                window.addToDataLayer({ event: "Education Articles Image" });
                                                                                changeFeedId(data.feedUrl);
                                                                            }}
                                                                            aria-label={data.title}
                                                                            tabIndex={-1}
                                                                        >
                                                                            <img
                                                                                style={{ left: "0%", top: "0%", transform: "none" }}
                                                                                src={data.imageUrl}
                                                                                alt="Article Image"
                                                                            />
                                                                        </a>
                                                                    </div>
                                                                    <div className="article-content">
                                                                        <h4 className="article-title">
                                                                            <a
                                                                                rel="noreferrer"
                                                                                onClick={() => {
                                                                                    window.addToDataLayer({ event: "Education Articles Link" });
                                                                                    // window.open(data.feedUrl, "_blank")
                                                                                    changeFeedId(data.feedUrl);
                                                                                }}
                                                                                href="javascript:void(0);"
                                                                                title={data.title}
                                                                            >
                                                                                {data.title.length > 57 ? data.title.substring(0, 57) + "..." : data.title}
                                                                            </a>
                                                                        </h4>
                                                                        <div className="article-intro">
                                                                            <p style={{ maxHeight: "100px", textOverflow: "ellipsis", overflow: "hidden" }}>
                                                                                {data && data.summary && data.summary.length > 197 ? data.summary.substring(0, 197) + "..." : data.summary}
                                                                            </p>
                                                                        </div>
                                                                    </div>
                                                                    {/* <div className="article-author-and-date">
                                                                        <div className="article-author-text">
                                                                            <div className="article-author-name">
                                                                                <span className="sr-only">Author: </span>
                                                                                {data.author}
                                                                            </div>
                                                                            <div className="article-published-date">
                                                                                <span className="sr-only">Published on: </span>
                                                                                {getFormattedDate(i18nService.get("Country"), data.publishDate)}
                                                                            </div>
                                                                        </div>
                                                                    </div> */}
                                                                </div>
                                                            </li>
                                                        ))}
                                                </ul>
                                                {/* <p className="text-align-right">
                                                    <a
                                                        onClick={() => window.addToDataLayer({ event: "View More Articles" })}
                                                        href={staticURLs.BusResEduBlogs}
                                                        target="_blank"
                                                        className="default_link"
                                                        rel="noreferrer"
                                                    >
                                                        View More Articles
                                                    </a>
                                                </p> */}
                                            </div>
                                        </div>

                                        <div className="col-xs-12 col-sm-12 col-gutter-vertical">
                                            <div className="row">
                                                <div className="col-xs-12 col-sm-6">
                                                    <h3 className="content-sub-title">Webinars</h3>
                                                    {webinarsData != null &&
                                                        webinarsData.map((data: any, index: number) => (
                                                            <div key={"webinars-" + index} className="resource-container">
                                                                <a
                                                                    href="javascript:void(0);"
                                                                    className="resource-link"
                                                                    onClick={() => {
                                                                        window.addToDataLayer({ event: "Webinars External Link" });
                                                                        changeFeedId(data.feedUrl);
                                                                    }}
                                                                >
                                                                    <span className="resource-icon">
                                                                        <em className="las la-tv"></em>
                                                                    </span>
                                                                    <span className="resource-text">
                                                                        <span className="resource-title">{data.title}</span>
                                                                        <span className="resource-description">{data.summary}</span>
                                                                    </span>
                                                                </a>
                                                            </div>
                                                        ))}

                                                    {/* <p className="text-align-right">
                                                        <a
                                                            onClick={() => window.addToDataLayer({ event: "View More Webinars" })}
                                                            href={staticURLs.BusResEduWebinars}
                                                            target="_blank"
                                                            className="default_link"
                                                            rel="noreferrer"
                                                        >
                                                            View More Webinars
                                                        </a>
                                                    </p> */}
                                                </div>
                                                <div className="col-xs-12 col-sm-6">
                                                    <h3 className="content-sub-title">Infographics</h3>

                                                    {infographicsData != null &&
                                                        infographicsData.map((data: any, index: number) => (
                                                            <div key={"infographics-" + index} className="resource-container">
                                                                <a
                                                                    href="javascript:void(0);"
                                                                    className="resource-link"
                                                                    onClick={() => {
                                                                        window.addToDataLayer({ event: "Infographics External Link" });
                                                                        changeFeedId(data.feedUrl);
                                                                    }}
                                                                >
                                                                    <span className="resource-icon">
                                                                        <em className="las la-file-image"></em>
                                                                    </span>
                                                                    <span className="resource-text">
                                                                        <span className="resource-title">{data.title}</span>
                                                                        <span className="resource-description">{data.summary}</span>
                                                                    </span>
                                                                </a>
                                                            </div>
                                                        ))}

                                                    {/* <p className="text-align-right">
                                                        <a
                                                            onClick={() => window.addToDataLayer({ event: "View More Infographics" })}
                                                            href={staticURLs.BusResEduInfographics}
                                                            target="_blank"
                                                            className="default_link"
                                                            rel="noreferrer"
                                                        >
                                                            View More Infographics
                                                        </a>
                                                    </p> */}
                                                </div>
                                            </div>
                                        </div>
                                    </>
                                ) : (
                                    <div className="box loading"></div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            ) : (
                <RssFeedDetails id={detailFeedId} backToArticles={changeDetailsView} />
            )}
        </React.Fragment>
    );
};

export default BusinessEducation;
